import Model from '@models/Model';
import _uniqueId from 'lodash/uniqueId';

// Use symbols for private attributes
const _properties = Symbol('properties');

export default class User extends Model {
    /**
     * The User class constructor.
     */
    constructor (data) {
        super(data, _properties);

        this[_properties]._uid = _uniqueId('user_');
    }

    /**
     * Getter for the user's unique ID.
     *
     * @return {String}
     */
    get uid () {
        return this[_properties]._uid;
    }

    /**
     * Getter for the user's notification frequency.
     *
     * @return {Number}
     */
    get notificationFrequency () {
        return Number(this[_properties].notification_frequency);
    }

    /**
     * Getter for the user's alias.
     *
     * @return {String}
     */
    get alias () {
        return this[_properties].alias;
    }

    /**
     * Getter for the user's username.
     *
     * @return {String}
     */
    get username () {
        return this[_properties].username;
    }

    /**
     * Getter for the user's email.
     *
     * @return {String}
     */
    get email () {
        return this[_properties].email;
    }

    /**
     * Getter for the user's profile image URI.
     *
     * @return {String}
     */
    get image () {
        return this[_properties].profile_image;
    }
}
